<template>
  <div>
    <main class="container-fluid">
      <section class="row">
        <div class="col-4 px-3 py-3 d-none d-md-flex"></div>
        <div
          class="col-24 col-md-11 px-md-3 py-md-3 pt-3 pt-md-0 px-3 px-md-0 mb-md-5"
        >
          <div class="col d-column">
            <h1
              class="title pt-2 mb-0"
              v-text="$ml.with(nameEmpresa).get('dashTitle')"
            ></h1>
            <h1 class="title">
              <span v-text="$ml.get('dashSubTitle')" class="pb-2"></span>
            </h1>
            <div class="card mb-3">
              <b-navbar-nav id="yearSelectDash" class="ml-auto">
                <b-nav-item-dropdown
                  :text="String(yearSelected)"
                  right
                  menu-class="minw-none"
                >
                  <b-dropdown-item @click="loadData(year - 1)">{{
                    year - 1
                  }}</b-dropdown-item>
                  <b-dropdown-item @click="loadData(year)">{{
                    year
                  }}</b-dropdown-item>
                </b-nav-item-dropdown>
              </b-navbar-nav>

              <div class="card-chart">
                <canvas id="chart-main" />
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-8 border-r-d mt-2">
                    <span
                      v-text="$ml.with(nameEmpresa).get('approvedReports')"
                    ></span>
                    <h6 style="margin-top: 1px">{{ total_reports }}</h6>
                  </div>
                  <div class="col pl-3 mt-2">
                    <span v-text="$ml.get('severityReports')"
                      >Relatórios por Severidade</span
                    >
                    <div class="row mt-1">
                      <div class="row mr-3">
                        <Impact impact="impact-low" class="mt-1 mr-1" />
                        <span
                          ><font v-text="$ml.get('low')">Baixo</font>:
                          {{ low_severity_reports }}
                        </span>
                      </div>

                      <div class="row mr-3">
                        <Impact impact="impact-medium" class="mt-1 mr-1" />
                        <span
                          ><font v-text="$ml.get('medium')">Médio</font>:
                          {{ medium_severity_reports }}
                        </span>
                      </div>

                      <div class="row mr-3">
                        <Impact impact="impact-high" class="mt-1 mr-1" />
                        <span
                          ><font v-text="$ml.get('high')">Alto</font>:
                          {{ high_severity_reports }}
                        </span>
                      </div>

                      <div class="row">
                        <Impact impact="impact-critical" class="mt-1 mr-1" />
                        <span
                          ><font v-text="$ml.get('critical')">Crítico</font>:
                          {{ critical_severity_reports }}</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card mb-3">
              <CardCreatProgram />
              <div class="row">
                <div
                  class="col-24 col-md-6 p-2 justify-content-center d-flex flex-column"
                >
                  <p class="text-center m-0" v-if="amount_programs.vdp == 0">
                    <font v-text="$ml.get('youDontHave')">Você não possui</font
                    >&nbsp;<b v-text="$ml.get('none').toLowerCase()">nenhum</b
                    >&nbsp;<b v-text="' VDP'">VDP</b>!
                  </p>
                  <p class="text-center m-0" v-if="amount_programs.vdp == 1">
                    <font v-text="$ml.get('youHave')">Você possui</font
                    >&nbsp;<b>
                      <router-link to="/program"
                        >{{ amount_programs.vdp }}&nbsp;<font v-text="' VDP'"
                          >VDP</font
                        >
                      </router-link></b
                    >
                  </p>
                  <p class="text-center m-0" v-if="amount_programs.vdp > 1">
                    <font v-text="$ml.get('youHave')">Você possui</font
                    >&nbsp;<b>
                      <router-link to="/program"
                        >{{ amount_programs.vdp }}&nbsp;<font v-text="' VDPs'">
                          VDP</font
                        >
                      </router-link></b
                    >
                  </p>
                </div>

                <div
                  class="col-24 col-md-6 p-2 justify-content-center d-flex flex-column"
                >
                  <p class="text-center m-0" v-if="amount_programs.public == 0">
                    <font v-text="$ml.get('youDontHave')">Você não possui</font
                    >&nbsp;<b v-text="$ml.get('none').toLowerCase()">nenhum</b
                    >&nbsp;<b v-text="$ml.get('publicProgram').toLowerCase()"
                      >programa público</b
                    >!
                  </p>
                  <p class="text-center m-0" v-if="amount_programs.public == 1">
                    <font v-text="$ml.get('youHave')">Você possui</font
                    >&nbsp;<b>
                      <router-link to="/program"
                        >{{ amount_programs.public }}&nbsp;<font
                          v-text="$ml.get('publicProgram').toLowerCase()"
                          >programa público</font
                        >
                      </router-link></b
                    >
                  </p>
                  <p class="text-center m-0" v-if="amount_programs.public > 1">
                    <font v-text="$ml.get('youHave')">Você possui</font
                    >&nbsp;<b>
                      <router-link to="/program"
                        >{{ amount_programs.public }}&nbsp;<font
                          v-text="$ml.get('publicPrograms').toLowerCase()"
                          >programas públicos</font
                        >
                      </router-link></b
                    >
                  </p>
                </div>

                <div
                  class="col-24 col-md-6 p-2 justify-content-center d-flex flex-column"
                >
                  <p
                    class="text-center m-0"
                    v-if="amount_programs.private == 0"
                  >
                    <font v-text="$ml.get('youDontHave')">Você não possui</font
                    >&nbsp;<b v-text="$ml.get('none').toLowerCase()">nenhum</b
                    >&nbsp;<b v-text="$ml.get('privateProgram').toLowerCase()"
                      >programa privado</b
                    >!
                  </p>
                  <p
                    class="text-center m-0"
                    v-if="amount_programs.private == 1"
                  >
                    <font v-text="$ml.get('youHave')">Você possui</font
                    >&nbsp;<b>
                      <router-link to="/program"
                        >{{ amount_programs.private }}&nbsp;<font
                          v-text="$ml.get('privateProgram').toLowerCase()"
                          >programa privado</font
                        >
                      </router-link></b
                    >
                  </p>
                  <p class="text-center m-0" v-if="amount_programs.private > 1">
                    <font v-text="$ml.get('youHave')">Você possui</font
                    >&nbsp;<b>
                      <router-link to="/program"
                        >{{ amount_programs.private }}&nbsp;<font
                          v-text="$ml.get('privatePrograms').toLowerCase()"
                          >programas privados</font
                        >
                      </router-link></b
                    >
                  </p>
                </div>

                <div
                  class="col-24 col-md-6 p-2 justify-content-center d-flex flex-column"
                >
                  <p class="text-center m-0" v-if="amount_programs.target == 0">
                    <font v-text="$ml.get('youDontHave')">Você não possui</font
                    >&nbsp;<b v-text="$ml.get('none').toLowerCase()">nenhum</b
                    >&nbsp;<b v-text="$ml.get('objectiveProgram').toLowerCase()"
                      >programa por objetivo</b
                    >!
                  </p>
                  <p class="text-center m-0" v-if="amount_programs.target == 1">
                    <font v-text="$ml.get('youHave')">Você possui</font
                    >&nbsp;<b>
                      <router-link to="/program"
                        >{{ amount_programs.target }}&nbsp;<font
                          v-text="$ml.get('objectiveProgram').toLowerCase()"
                          >programa por objetivo</font
                        >
                      </router-link></b
                    >
                  </p>
                  <p class="text-center m-0" v-if="amount_programs.target > 1">
                    <font v-text="$ml.get('youHave')">Você possui</font
                    >&nbsp;<b>
                      <router-link to="/program"
                        >{{ amount_programs.target }}&nbsp;<font
                          v-text="$ml.get('objectivePrograms').toLowerCase()"
                          >programa por objetivo</font
                        >
                      </router-link></b
                    >
                  </p>
                </div>
              </div>
            </div>
            <!-- Timeline( :title="'Hackivity Recente'")  -->
          </div>
        </div>

        <!-- Cards do lado direito, help e ranking -->
        <div class="col-24 col-md-5 pr-md-3 py-md-3 px-3 px-md-0">
          <section>
            <Help />
            <div
              v-show="this.new || this.triaged || this.under_review"
              class="card card-visitors mb-3"
            >
              <div class="card-header card-chart-mini">
                <div class="d-flex flex-row">
                  <span v-text="$ml.get('trackYourOpenReports')"
                    >Acompanhe seus relatórios abertos</span
                  >
                </div>
              </div>
              <div class="card-body">
                <canvas id="chartReportsOpen"
                  >Your browser does not support the canvas element.</canvas
                >
              </div>
            </div>
            <Ranking />
          </section>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import Help from "../../../components/help";
import Ranking from "../../../components/ranking";
import CompanyService from "../../../services/company.service";
import Swal from "sweetalert2";
// import Timeline from "../../../components/company/timeline";

import Chart from "chart.js";
import accountService from "../../../services/account.service";

export default {
  components: {
    Help,
    Ranking,
  },
  data() {
    return {
      nameEmpresa: "",
      total_reports: "",

      amount_programs: [],

      low_severity_reports: "",
      medium_severity_reports: "",
      high_severity_reports: "",
      critical_severity_reports: "",

      new: 0,
      triaged: 0,
      under_review: 0,
      language: this.$ml.current,
      year: 2000,
      yearSelected: 2000,
    };
  },
  watch: {
    language() {
      this.loadData();
    },
  },
  created() {
    var today = new Date();
    this.year = today.getFullYear();
    this.loadData(this.year);
  },
  mounted() {
    this.nameEmpresa = this.$store.getters["getUser"].name;
    this.amount_programs = this.$store.getters["getAmount_programs"];
    this.fetchData();
  },

  methods: {
    async fetchData() {
      try {
        const response = await accountService.getAccountMy();
        const { language } = response?.data;
        let preferredLanguage =
          language === "en"
            ? "english"
            : language === "es"
              ? "spanish"
              : "portuguese";
        const ln_storage = localStorage.getItem("vueml-lang");
        if (ln_storage != preferredLanguage) {
          window.location.reload(true);
          localStorage.setItem("vueml-lang", preferredLanguage);
        }
      } catch (error) {
        console.log(error);
      }
    },

    loadData(year) {
      var self = this;

      this.yearSelected = year;

      CompanyService.getReportsSummary(year).then(
        (response) => {
          let resp = response.data;
          this.total_reports = resp.total_reports;
          this.low_severity_reports = resp.low_severity_reports;
          this.medium_severity_reports = resp.medium_severity_reports;
          this.high_severity_reports = resp.high_severity_reports;
          this.critical_severity_reports = resp.critical_severity_reports;
          this.loadChart(resp);
        },
        ({ response }) => {
          if (response.status !== 401) {
            Swal.fire({
              icon: "info",
              title: "",
              text: self.$ml.get("unableToCompleteThisRequest"),
            });
          }
        }
      );

      CompanyService.getReportsSituationSummary().then(
        (response) => {
          let resp = response.data;
          this.under_review = resp.under_review;
          this.triaged = resp.triaged;
          this.new = resp.new;
          this.loadChartReport(resp);
        },
        ({ response }) => {
          if (response.status !== 401) {
            Swal.fire({
              icon: "info",
              title: "",
              text: self.$ml.get("unableToCompleteThisRequest"),
            });
          }
        }
      );
    },
    loadChart(months) {
      var ctx = document.getElementById("chart-main").getContext("2d");
      new Chart(ctx, {
        // The type of chart we want to create
        type: "line",

        // The data for our dataset
        data: {
          labels: [
            "Janeiro",
            "Fevereiro",
            "Março",
            "Abril",
            "Maio",
            "Junho",
            "Julho",
            "Agosto",
            "Setembro",
            "Outubro",
            "Novembro",
            "Dezembro",
          ],
          datasets: [
            {
              label: "Reports",
              backgroundColor: "RGBA(115, 11, 169, 0.2)",
              borderColor: "#730BA9",
              data: [
                months.jan,
                months.feb,
                months.mar,
                months.apr,
                months.may,
                months.jun,
                months.jul,
                months.aug,
                months.sep,
                months.oct,
                months.nov,
                months.dec,
              ],

              pointBackgroundColor: [
                "#FFFFFF",
                "#FFFFFF",
                "#FFFFFF",
                "#FFFFFF",
                "#FFFFFF",
                "#FFFFFF",
                "#FFFFFF",
                "#FFFFFF",
                "#FFFFFF",
                "#FFFFFF",
                "#FFFFFF",
                "#FFFFFF",
              ],
              pointBorderColor: [
                "RGBA(115, 11, 169, 1)",
                "RGBA(115, 11, 169, 1)",
                "RGBA(115, 11, 169, 1)",
                "RGBA(115, 11, 169, 1)",
                "RGBA(115, 11, 169, 1)",
                "RGBA(115, 11, 169, 1)",
                "RGBA(115, 11, 169, 1)",
                "RGBA(115, 11, 169, 1)",
                "RGBA(115, 11, 169, 1)",
                "RGBA(115, 11, 169, 1)",
                "RGBA(115, 11, 169, 1)",
                "RGBA(115, 11, 169, 1)",
              ],
              pointBorderWidth: 1,
              borderWidth: 1,
              pointRadius: 4,
            },
            {
              backgroundColor: "rgb(255,255,255, 0.3)",
              borderColor: "#ffffff",

              data: [12],
            },
          ],
        },
        // Configuration options go here
        options: {
          responsive: true,
          maintainAspectRatio: false,
          spanGaps: false,
          layout: {
            padding: {
              left: -4,
              right: 10,
              top: 5,
              bottom: 5,
            },
          },
          elements: {
            line: {
              tension: 0.000001,
            },
            point: {
              radius: 0,
            },
          },
          legend: {
            display: false,
          },
          scales: {
            yAxes: [
              {
                gridLines: {
                  display: false,
                  drawBorder: false,
                },
                ticks: {
                  beginAtZero: false,
                  display: false,
                },
              },
            ],
            xAxes: [
              {
                gridLines: {
                  display: false,
                  drawBorder: false,
                },
                ticks: {
                  beginAtZero: false,
                  display: false,
                },
              },
            ],
          },
        },
      });
    },
    loadChartReport(resp) {
      var self = this;
      new Chart(document.getElementById("chartReportsOpen"), {
        type: "doughnut",
        data: {
          labels: [
            self.$ml.get("v_new").charAt(0).toUpperCase() +
              self.$ml.get("v_new").slice(1),
            self.$ml.get("v_triaged").charAt(0).toUpperCase() +
              self.$ml.get("v_triaged").slice(1),
            self.$ml.get("v_under_review").charAt(0).toUpperCase() +
              self.$ml.get("v_under_review").slice(1),
          ],
          datasets: [
            {
              label: "",
              data: [resp.new, resp.triaged, resp.under_review],
              backgroundColor: ["#730ca8", "#8a73af85", "#ccbde485"],
            },
          ],
        },
        options: {
          legend: {
            display: true,
          },
        },
      });
    },
  },
};
</script>
<style>
#yearSelectDash {
  position: absolute;
  right: 10px;
}
.minw-none {
  min-width: 0 !important;
}
</style>
